import { useStore } from "../../stores/StoreContext";
import { UserManagementService } from "../LogicServices/UserManagementSerivce";

export function useUserManagementService(): UserManagementService {
  const storeContext = useStore();
  return new UserManagementService(storeContext);
}
